import React from 'react';
import { Header } from './../Calculators/Header';
import { Intro } from './../Calculators/Intro';
import { ErrorBox } from './../PartialRepayment/Sidebar';
import { ButtonPanel } from './../Calculators/ButtonPanel';
import { Centered, CalculatorSection } from './../Calculators/Sections';
import { Button, ButtonLink, TextInput, RadioButton, RangerInput } from './../Form/index';
import { LevelsOfEnhancement } from './LevelsOfEnhancement';

const titleLtv = [
  // 'While your client might seem fit and healthy it’s always important to ask them our 13 health questions as their health',
  // 'can have a significant impact on the loan your client could qualify for. See how the amount your client could release',
  // 'changes depending on the severity of their health issues.'
];

const ClientDetails = ({ input, onChangeInput }) => (
  <CalculatorSection>
    <div className="title">Client Details</div>
    <div className="section-row">

      <div className="column-icon">
        <img src="images/icon-people.png" />
      </div>
      <div className="section-inner">
        <div className="radio-container" style={{ paddingTop: 10 }}>
          <RadioButton
              minWidth={115}
              value={true}
              side='right'
              checked={input.isJoint === false}
              onChange={() => onChangeInput('isJoint', false)}
            >
            <div className="label">Single life</div>
          </RadioButton>
          <RadioButton
            value={false}
            minWidth={120}
            side='right'
            checked={input.isJoint === true}
            onChange={() => onChangeInput('isJoint', true)}
          >
            <div className="label">Joint life</div>
          </RadioButton>
        </div>

        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div className="column" style={{ padding: 0 }}>
            <div style={{ paddingTop: 10 }}>
              <div className="label">
                Age <small>(youngest if couple)</small>
              </div>
            </div>
          </div>
          <div className="column" style={{ padding: 0, paddingRight: 10 }}>
            <RangerInput
              value={input.clientAge} min={(input.isJoint) ? 55 : 55} max={84} withLabel={true}
              color='#0a2f70' inactiveColor='#bbbbbb'
              onChange={val => { onChangeInput('clientAge', val) }}
            />
          </div>
        </div>
      </div>

      <div className="column-gap"></div>

      <div className="column-icon">
        <img src="images/icon-house.png" />
      </div>
      <div className="small-column section-inner">
        <div className="label">Value of home</div>
        <div>
          <TextInput
            width={150}
            type="currency" prefixes="&pound;" value={input.housePrice} onChange={val => { onChangeInput('housePrice', val) }} />
        </div>
      </div>
    </div>

    {(input.housePrice < 99000) ? (
      <div className="section-row">
        <div style={{ margin: '20px 0px', width: '100%' }}>
          <ErrorBox style={{ fontSize: 14, marginTop: 0 }}>
            The minimum property value required is £99,000
          </ErrorBox>
        </div>
      </div>
    ): false}

  </CalculatorSection>
);

export const LtvCalculatorComponent = (props) => {
  const { screen, partialRepayment, onChangeInput, onChangePlan } = props;
  const { match } = props
  const hideLink = match && match.params && parseInt(match.params.Id, 10) === 1;
  return (
    <div>
      <Centered>
        <ClientDetails {...partialRepayment} onChangeInput={onChangeInput} />
        <LevelsOfEnhancement {...partialRepayment} onChangePlan={onChangePlan} hideLink={hideLink} />
      </Centered>

      {screen.inFrame ? false : (
        <ButtonPanel className="footer">
          <ButtonLink to='/'>Back</ButtonLink>
          <div style={{ flex: 1 }}></div>
        </ButtonPanel>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/LtvCalculator/LtvCalculatorComponent.js